export default "__VITE_ASSET__C22kMG_d__"